module.exports = __webpack_public_path__ + "static/img/pergunta-adicional.acdf186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pergunta-adicional.png
// module id = mKkH
// module chunks = 1